import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fromPath = location.state?.from || "this section";

  return (
    <div className="flex ml-64 bg-gray-200 min-h-screen">
      <div className="m-auto max-w-xl bg-white shadow-lg rounded-md p-10 text-center">
        <h1 className="text-3xl font-semibold text-red-600 mb-4">
          Access Restricted
        </h1>
        <p className="text-gray-700 mb-6">
          You don&apos;t have permission to view{" "}
          <span className="font-semibold">{fromPath}</span>. Please contact your
          administrator if you believe this is a mistake.
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate("/dashboard/manageUser")}
            className="px-6 py-2 rounded-md bg-bgclr text-white hover:bg-blue-600"
          >
            Go to CMS Users
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;

